import { render } from "./StoryAccess.vue?vue&type=template&id=1981aecf&scoped=true"
import script from "./StoryAccess.vue?vue&type=script&lang=js"
export * from "./StoryAccess.vue?vue&type=script&lang=js"

import "./StoryAccess.vue?vue&type=style&index=0&id=1981aecf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1981aecf"]])

export default __exports__